export default __webpack_public_path__ + "static/media/eatingtimes_2@2x.59a6fab0.jpg";